import React from "react"

import {LexicalEditor} from "lexical"
import PopupMenuButton from "../../../../../popover-menu/popup-menu-button/popup-menu-button"
import {CODE_LANGUAGE_FRIENDLY_NAME_MAP} from "@lexical/code"
import ToolbarCodeLanguageMenu from "./code-language-menu"
import ToolbarCodeLanguageButton from "./code-language-button"
import {NodeKey} from "lexical/LexicalNode"

type Props = {
    editor              : LexicalEditor
    selectedElementKey  : NodeKey | null
    codeLanguage        : string
}

const debug = false
// const debug = "CodeLanguageToolbar"

export default function CodeLanguageToolbar(props: Props): JSX.Element {

    const options: any[] = []
    _.mapKeys(CODE_LANGUAGE_FRIENDLY_NAME_MAP, (value ,key)=>{
        options.push({value: key, label: value})
    })

    debug && console.log(debug, 'render', props)

    return (
        <div className="gd-draftail-toolbar-group no-separator">
            <PopupMenuButton hint           = "Select style"
                             btnComponent   = {ToolbarCodeLanguageButton}
                             menuComponent  = {ToolbarCodeLanguageMenu}
                             menuParams     = {{
                                 options            : options,
                                 editor             : props.editor,
                                 selectedElementKey : props.selectedElementKey,
                                 codeLanguage       : props.codeLanguage,
                             }}/>
        </div>
    )
}